<template>
    <div class="form-select stylized">
        <label class="outside-label" v-if="outsideLabel">{{ outsideLabel }}</label>
        <div class="dropdown-select-wrap native">
            <select :name="name" class="dropdown-select" v-model="selected">
                <option v-bind:value="anyOption">{{ anyOption[0] }}</option>
                <option
                    :value="option"
                    :key="index"
                    v-for="(option,index) of filteredOptions"
                >{{ option[0] }}</option>
            </select>
        </div>
    </div>
</template>

<script>
function parse_query_string(query) {
    var vars = query.split("&");
    var query_string = {};
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        // If first entry with this name
        if (typeof query_string[pair[0]] === "undefined") {
            query_string[pair[0]] = decodeURIComponent(pair[1]);
            // If second entry with this name
        } else if (typeof query_string[pair[0]] === "string") {
            var arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
            query_string[pair[0]] = arr;
            // If third or later entry with this name
        } else {
            query_string[pair[0]].push(decodeURIComponent(pair[1]));
        }
    }
    return query_string;
}

export default {
    props: [
        "label",
        "options",
        "anyOption",
        "outsideLabel",
        "model",
        "redirect",
        "icon",
        "customEmit"
    ],
    data: function() {
        return {
            dropdown: this.label,
            name: this.label,
            selected: this.anyOption,
            filterOptions: false,
            defaultOptions: false
        };
    },
    computed: {
        filteredOptions() {
            if (this.anyOption && this.anyOption[2] == 'plan_id' && this.filterOptions) {
                return this.options.filter((option, i) => {
                    return this.filterOptions.indexOf(parseInt(option[2])) > -1 ? true : false;
                });
            } else if (this.anyOption && this.anyOption[2] == 'community_id' && this.filterOptions) {
                return this.options.filter((option, i) => {
                    return option[3] == this.filterOptions;
                });
            } else {
                return this.defaultOptions;
            }
        }
    },
    watch: {
        selected: function(is, was) {
            // Handles the community reset when a new city is selected
            if (!is) {
                // this.filterOptions = false;
                return this.selected = this.anyOption;
            }

            if ((is && was) && [0] === was[0]) {
                return;
            }

            if (this.anyOption) {
                if (is[1] === this.anyOption[1]) {
                    this.emitUnset();
                    return;
                }
            }
            this.emitSelected();
        },
        options: function(is, was) {
            // first time options are set, check the querystring
            var query = window.location.search.substring(1);
            var qs = parse_query_string(query);
            if (typeof qs[this.options[0][2]] != "undefined") {
                var sel = qs[this.options[0][2]];
                var match = this.options.filter(function(o) {
                    return o[1] == sel;
                });
                if (match.length > 0) {
                    this.selected = match.pop();
                }
            }
        }
    },
    beforeMount() {
        this.defaultOptions = this.options;
    },
    mounted() {
        if (this.customEmit) {
            this.$eventsBus.$on(this.customEmit, this.handleCustomEvent);
            this.$eventsBus.$on('unset-custom', this.resetCommunityDropdown);
        }
    },
    methods: {
        emitSelected: function() {
            this.$eventsBus.$emit("select-option", this.selected);
            if (this.redirect) {
                window.location.assign(this.selected[1]);
            }
            if (this.selected[1] === "city" && this.customEmit) {
                this.$eventsBus.$emit(this.customEmit, this.selected);
            }
        },
        emitUnset: function() {
            this.$eventsBus.$emit("unset-option", this.selected);
            if (this.selected[2] === "city" && this.customEmit) {
               this.$eventsBus.$emit('unset-custom', this.selected);
            }
        },
        handleCustomEvent: function(event) {
            // For MIR filters. Structure:
            // ["Display Value", "Search String", search value, association id]
            // Ex: ["Hawkstone", "community_id", 1, 2]
            if (this.anyOption && this.anyOption[2] == 'community_id') {
                this.filterOptions = event[3] ;
            } else if (this.anyOption && this.anyOption[2] == 'plan_id') {
                this.filterOptions = event[4] ;
            } else {
                this.filterOptions = false;
            }
        },
        resetCommunityDropdown: function() {
            this.filterOptions = false;
            this.selected = this.anyOption;
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/components/atoms/dropdown-select.vue